import script from "./FiltersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersSection.vue?vue&type=script&setup=true&lang=js"

import "./FiltersSection.vue?vue&type=style&index=0&id=33384eca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33384eca"]])

export default __exports__